import React from 'react'
import {SidebarRealm} from './types'
import SidebarRealmsView from './SidebarRealmsView'
import {getRealmAdminMode} from 'selectors/ninchat/adminMode'
import {navigation} from '../../../navigation'
import {useAppSelector} from '../../../hooks'
import {useRealms} from '../../../hooks/ninchat'

const SidebarRealms = (): React.ReactElement => {
    const appRealms = useRealms()
    const ninchat = useAppSelector(({ninchat: state}) => state)
    const navigationSt = useAppSelector(({navigation: navigationState}) => navigationState)

    const realms = [...Object.entries(appRealms)]
        .map(([realm_id, realm]) => ({
            admin: realm.realm_attrs.permissions_enabled === true && !!ninchat.user_attrs.admin,
            adminMode: getRealmAdminMode(ninchat, realm_id, realm).enabled,
            name: realm.realm_attrs.name,
            realm_id,
        }))
        .sort((a, b) => ((a.name?.toLowerCase() ?? '') < (b.name?.toLowerCase() ?? '') ? -1 : (a.name?.toLowerCase() ?? '') > (b.name?.toLowerCase() ?? '') ? 1 : 0)) as SidebarRealm[]

    const selectedRealmId = useAppSelector(({ui}) => ui.realm_id)

    const selectedRealmName = useAppSelector(({
        ninchat: selectedNinchat, ui,
    }) => {
        const realmId = ui.realm_id
        const selectedRealmAttrs = realmId ? appRealms[realmId]?.realm_attrs : selectedNinchat.user_realms[Object.keys(selectedNinchat.user_realms)[0]]?.realm_attrs || null
        return selectedRealmAttrs?.name
    })

    const handleRealmChange = (realm_id?: string): void => {
        navigation.push('Realm', {
            ...navigationSt.routes[navigationSt.position]?.params || {},
            realm_id,
        })
    }

    const loadRealm = (realm_id: string | undefined): void => {
        if (realm_id) {
            navigation.push('Realm', {realm_id})
        }
    }

    return (
        <SidebarRealmsView
            handleRealmChange={handleRealmChange}
            loadRealm={loadRealm}
            realms={realms}
            selectedRealmId={selectedRealmId}
            selectedRealmName={selectedRealmName}
        />
    )
}

export default SidebarRealms
